export const subtitles = {
    "1": {
        "startTime": 8.15,
        "endTime": 9.05,
        "transcript": "Tua-llu?",
        "translation": "Ready?"
    },
    "2": {
        "startTime": 10.565,
        "endTime": 12.595,
        "transcript": "Kituusit Kass'atun atren?",
        "translation": "Who are you in English?"
    },
    "3": {
        "startTime": 12.895,
        "endTime": 13.775,
        "transcript": "Helen.",
        "translation": "Helen."
    },
    "4": {
        "startTime": 14.34,
        "endTime": 15.59,
        "transcript": "Yugtun-llu?",
        "translation": "And in Yup'ik?"
    },
    "5": {
        "startTime": 16.06,
        "endTime": 17.21,
        "transcript": "Narr'aq.",
        "translation": "Narr'aq."
    },
    "6": {
        "startTime": 17.21,
        "endTime": 19.91,
        "transcript": "Naparyarrarmiunguluten-llu? (Yaa.)",
        "translation": "And you're from Napakiak? (Yes.)"
    },
    "7": {
        "startTime": 19.925,
        "endTime": 22.545,
        "transcript": "Maani-ll'-qaa yuurtellruluten? (Yaa.)",
        "translation": "And were you born here? (Yes.)"
    },
    "8": {
        "startTime": 27.36,
        "endTime": 29.34,
        "transcript": "Qangvaq yuurtellrusit?",
        "translation": "When were you born?"
    },
    "9": {
        "startTime": 30.615,
        "endTime": 32.415,
        "transcript": "Cami ima?",
        "translation": "When was it again?"
    },
    "10": {
        "startTime": 34.24,
        "endTime": 36.56,
        "transcript": "Ava-i angllulqa qama'ancaaquq.",
        "translation": "My baptism record is in there."
    },
    "11": {
        "startTime": 36.575,
        "endTime": 37.435,
        "transcript": "October?",
        "translation": "October?"
    },
    "12": {
        "startTime": 37.82,
        "endTime": 38.95,
        "transcript": "October 1.",
        "translation": "October 1."
    },
    "13": {
        "startTime": 40.42,
        "endTime": 45.02,
        "transcript": "Nineteen-aara-w' nallukeka. Kia-i angllulqa uitayaaquq.",
        "translation": "I'm not sure when in the 1900's. My baptism record is in there."
    },
    "14": {
        "startTime": 47.575,
        "endTime": 49.905,
        "transcript": "Irniarluten-llu cetamanek?",
        "translation": "And you have four children?"
    },
    "15": {
        "startTime": 51.495,
        "endTime": 52.715,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "16": {
        "startTime": 55.06,
        "endTime": 56.46,
        "transcript": "Yaa, cetamanek.",
        "translation": "Yes, four."
    },
    "17": {
        "startTime": 57.255,
        "endTime": 60.075,
        "transcript": "Tut'gararluten-llu qula ataucimek?",
        "translation": "And you have eleven grandchildren?"
    },
    "18": {
        "startTime": 61.72,
        "endTime": 64.37,
        "transcript": "Iluperauten-llu qula atauciq?",
        "translation": "And eleven great-grandchildren?"
    },
    "19": {
        "startTime": 77.82,
        "endTime": 86.9,
        "transcript": "Imumi ellangellerpeni manalallrata ak'aqucuk Kass'at manassuutait pivailgata",
        "translation": "Back when you were growing up when they fished long ago before Western fishing rods appeared"
    },
    "20": {
        "startTime": 87.145,
        "endTime": 94.995,
        "transcript": "Canek atulallruat Kass'artarnek kuvyassuutnek pivkenateng, wall'u-q' manassuutet iciw' au͡gkut?",
        "translation": "What did they use instead of Western gill nets or those fishing rods?"
    },
    "21": {
        "startTime": 96.125,
        "endTime": 106.895,
        "transcript": "Tamaani tanglallruunga mananek Kass'artarnek tangerpek'nii tau͡gaam pilianek, ussukcarrarnek-llu waten kukeggluteng.",
        "translation": "Back then, I used to see non-Western fishing lines with hoods, and they had little nails fastened to the heads."
    },
    "22": {
        "startTime": 107.255,
        "endTime": 110.425,
        "transcript": "Ilait tua-i uivvaaryulriit anagiyugaqluteng.",
        "translation": "Some that spun would let the fish escape."
    },
    "23": {
        "startTime": 110.475,
        "endTime": 121.905,
        "transcript": "Tulurraat, pit-wa, tuntut-wa cirunrit, tamakut tamaa-i manauluki tanglaranka.",
        "translation": "Little pieces of ivory, and, you know, caribou antlers, I used to see tham used for fishing hooks."
    },
    "24": {
        "startTime": 121.955,
        "endTime": 131.795,
        "transcript": "Makut-llu tua-i luuskaat, ilaita luuskaat manaliaqluki epuit amilicarluki kukekluki.",
        "translation": "And they would make fishing hoods out of spoons, some spoons, by shaving down their handles to use as fastening on the heads."
    },
    "25": {
        "startTime": 133.85,
        "endTime": 138.26,
        "transcript": "Tamakunek tua-i kic'ugngalrianek manaruaraqluteng.",
        "translation": "They made old-fashoined fish hooks out of those things that could sink."
    },
    "26": {
        "startTime": 139.82,
        "endTime": 143.26,
        "transcript": "Ukaqvaggun maa-i manat pingellrulriit.",
        "translation": "Fishing lines and hooks came recently."
    },
    "27": {
        "startTime": 147.265,
        "endTime": 152.165,
        "transcript": "Canek ellangurallerpeni tanglallrusit wall'u-q' niitelallrusit?",
        "translation": "What did you see or hear about in your early childhood?"
    },
    "28": {
        "startTime": 155.21,
        "endTime": 165.15,
        "transcript": "Tua-i-w' au͡gkut, au͡gkut tua-i wiinga angullrunritanka iciw' nangteqeqapiggluteng yuulriit.",
        "translation": "Well, I wasn't born in time to see those who lived extremely hard lives back then."
    },
    "29": {
        "startTime": 165.775,
        "endTime": 175.635,
        "transcript": "Waten Kass'artarluki-ll' murilkellruunga. Maani-llu ellangua Kass'artarluni, Kass'arluta au͡g'umek Kass'all'e'rmek piaqluku.",
        "translation": "And I observed a time with Caucasians like this. And I grew up here with Caucasians, with one among us whom we called Kass'all'er."
    },
    "30": {
        "startTime": 176.22,
        "endTime": 179.52,
        "transcript": "Taumek tua-i. Maani-ll' call' qavani Kass'artarluni.",
        "translation": "That was him. There were also Caucasians upriver."
    },
    "31": {
        "startTime": 180.325,
        "endTime": 184.955,
        "transcript": "Tau͡gaam tamakut-wa tua-i pingraata",
        "translation": "But even though that's the case"
    },
    "32": {
        "startTime": 185.685,
        "endTime": 193.405,
        "transcript": "Qanqeryugtua waten yuut assirluteng yuullerkait tamakut qanruyutektulput.",
        "translation": "I want to talk about our traditional wisdom about how people should live well like this."
    },
    "33": {
        "startTime": 193.62,
        "endTime": 204.71,
        "transcript": "Cali-llu cat assiinaku waten qaneryaramek niicuitellermeggni, agayulrianek-llu niicuitellermeggni",
        "translation": "But bad things, when they didn't hear about the Bible like this, or about religions"
    },
    "34": {
        "startTime": 204.76,
        "endTime": 213.82,
        "transcript": "Qanruyutellrit wangnun wall'u niitellrenka, tamakut maa-i ilait eneqakumalaryaaqanka.",
        "translation": "I recall now some of the traditional wisdom they passed down to me or that I heard."
    },
    "35": {
        "startTime": 213.945,
        "endTime": 219.615,
        "transcript": "Tau͡gaam qanrutku'rciiganaki, tau͡gaam piyunarqelriamun qanrutkaqluki.",
        "translation": "But I can't always speak about them, only to those who are willing."
    },
    "36": {
        "startTime": 219.615,
        "endTime": 228.135,
        "transcript": "Iciw'-llu elpeceńun arcaqerluci qanrut'laryaaqamci assirluci yuullerkarpeceńek.",
        "translation": "And, you know, I tell especially you guys how you should live well."
    },
    "37": {
        "startTime": 228.51,
        "endTime": 236.98,
        "transcript": "Yuum waten qanruyutni tau͡gaam maliggluki yuulriim elluarrluni yuutuuq, yuutulliniuq.",
        "translation": "Only a person who adheres to the traditional wisdom passed down to him like this lives a good life."
    },
    "38": {
        "startTime": 237.78,
        "endTime": 251.0,
        "transcript": "Tau͡gken waten qanruyutni maligtenrilkii tua-i unguvaqacuaqerluni, wall' qanruyutni atuqii unguvamaqerluni.",
        "translation": "However, he who does not adhere to the traditional wisdom passed down to him lives a short life, or he who adheres to them lives a longer life."
    },
    "39": {
        "startTime": 251.275,
        "endTime": 262.105,
        "transcript": "Waten au͡gkut qantullruluteng: \"Yuk-gguq qanruyutminun maligtaqulluni erenra aipirluku unguvatuuq.",
        "translation": "They used to say this long ago: \"A person who adheres to the traditional wisdom passed down to him lives to see another day."
    },
    "40": {
        "startTime": 262.585,
        "endTime": 269.585,
        "transcript": "\"Tau͡gken-gguq qanruyutminek narurciluni yuulria erenrem iquani unguvalriatun ayuqluni.\"",
        "translation": "\"However, he who disobeys traditional wisdom only lives until the end of the day.\""
    },
    "41": {
        "startTime": 269.91,
        "endTime": 282.21,
        "transcript": "Maa-i-llu mat'um nalliini makut wani ayagyuat, elpeci tua-i ayagyuani-llu allaurtuci avanicetun tanglallemcetun.",
        "translation": "And young people these days, you young people have become different from what we used to see back then."
    },
    "42": {
        "startTime": 282.315,
        "endTime": 291.495,
        "transcript": "Wiinga-llu tua-i waten assiileng'e'rma qanruyutenka nalluvkenaki umyuaqetuluki pillruunga.",
        "translation": "And even though I am bad like this, I knew and remembered the traditional wisdom passed down to me."
    },
    "43": {
        "startTime": 292.12,
        "endTime": 296.14,
        "transcript": "Maa-i-llu mat'um nalliini yuut allayuurrluteng.",
        "translation": "And these days, people have become very different."
    },
    "44": {
        "startTime": 296.595,
        "endTime": 304.115,
        "transcript": "Tuar tang ellalegtairulluni, wall'u canek tua-i murilkiyuilnguurtellriatun ayuqluteng.",
        "translation": "It seems there's no more sensible people, or they've become unobservant of anything."
    },
    "45": {
        "startTime": 304.13,
        "endTime": 310.13,
        "transcript": "Tuar-llu cikmirmun ayalriacetun maa-i mat'um nalliini ayuqliulluteng.",
        "translation": "And it seems they are starting to live as blind people these days."
    },
    "46": {
        "startTime": 310.175,
        "endTime": 323.535,
        "transcript": "Waten-llu qanruyutmeggnek, qanruyutnek-wa makuni-llu maa-i KYUK-ni wiinga amllerqunek qanruyutnek waten niitelaryaaqua niicugniurayuileng'e'rma.",
        "translation": "And the traditional wisdom, I do hear about traditional wisdom through KYUK here as well even though I don't always listen in."
    },
    "47": {
        "startTime": 324.85,
        "endTime": 335.42,
        "transcript": "Tau͡gaam tamakut tuar tang amllerem tayima-llu niicuitelaqai. Waten ayagyuani arcaqerluki niicuitelarngat'laqait.",
        "translation": "But it seems many do not hear them. It seems that young people especially do not hear about them."
    },
    "48": {
        "startTime": 336.16,
        "endTime": 349.54,
        "transcript": "Maa-i makut waten yuum elluarrluki wall'u angayuqaagminek, angayuqaagni niiculukek yuullerkaa, tamana-llu maa-i niiqurayuirulluku.",
        "translation": "And now, they don't hear about how to live well or to treat their parents wells, living in obedience to their parents."
    },
    "49": {
        "startTime": 349.58,
        "endTime": 353.5,
        "transcript": "Agayuvigni tau͡gaam niitaqluta qanruyutnek.",
        "translation": "We only hear about wisdom in church."
    },
    "50": {
        "startTime": 354.11,
        "endTime": 362.37,
        "transcript": "Taumek waten wangkuta waten ellilriani qanrutarkaput tutgaraput wall'u irniaput",
        "translation": "That's why we who have reached this age that must teach our grandchildren or our children"
    },
    "51": {
        "startTime": 362.63,
        "endTime": 373.36,
        "transcript": "Makunek maa-i niitellemteńek wall'u wangkutnun qanruyutellemteńek tua-i qanrutaqluki pinaqsaaqaput.",
        "translation": "We must talk to them about these things we've heard or the traditional wisdom passed down to us."
    },
    "52": {
        "startTime": 373.79,
        "endTime": 384.08,
        "transcript": "Atam nasaurluq arcaqerluni waten qanruyutengqellruuq, tan'gaurluq-llu cali allakarmi qanruyutengqerrluni.",
        "translation": "You see, girls especially had traditional wisdom concerning them, and boys had separate wisdom concerning them."
    },
    "53": {
        "startTime": 384.81,
        "endTime": 388.87,
        "transcript": "Nasaurluq waten alerquutengqellruluni",
        "translation": "A girl had this instruction"
    },
    "54": {
        "startTime": 389.88,
        "endTime": 401.52,
        "transcript": "Waten tan'guarlurmun arnamun piksailngurmun tamakunun tua-i-wa mulngakluku yuullerkaa",
        "translation": "To keep boys who had not had women living carefully"
    },
    "55": {
        "startTime": 401.61,
        "endTime": 405.38,
        "transcript": "Waten qanrumiimi: \"Arnaq-gguq tuquuguq.\"",
        "translation": "Because it says this: \"A woman leads to death.\""
    },
    "56": {
        "startTime": 406.06,
        "endTime": 417.75,
        "transcript": "Wiinga-llu tamana tua-i ayagyuallemni aliketulqa waten, waten tuquuralrianek tangyuitellemteńi alikellruamteki",
        "translation": "I also used to fear this when I was young, people we feared it when we didn't see many people dying"
    },
    "57": {
        "startTime": 417.82,
        "endTime": 422.75,
        "transcript": "Wiinga-llu alikellruamki waten tangerrsaqliraqam.",
        "translation": "And I feared them when I saw death since a long time."
    },
    "58": {
        "startTime": 423.6,
        "endTime": 428.5,
        "transcript": "Taumek tuaten pituyukluki alikellrukeka.",
        "translation": "I feared it since I thought that would happen."
    },
    "59": {
        "startTime": 428.59,
        "endTime": 440.42,
        "transcript": "Waten tan'gaurlurmun aipangeksailnguq wall' nasaurluq aipangeksailnguq, tamakunun mulngakutesqellruuq, mulngakutesqellruat.",
        "translation": "They told them to be careful with unmarried boys or unmarried girls."
    },
    "60": {
        "startTime": 440.66,
        "endTime": 444.8,
        "transcript": "Tua-i-gguq nasaurluum tan'gaurluq tuqutarkaugaa.",
        "translation": "They said that a girl would bring death upon a boy."
    },
    "61": {
        "startTime": 445.05,
        "endTime": 450.2,
        "transcript": "Tua-i-llu ilii maa-i nallunailngurmek tuaten ayuqaqluni.",
        "translation": "And some now are certainly like that."
    },
    "62": {
        "startTime": 450.26,
        "endTime": 461.93,
        "transcript": "Maa-i makut qanruyutektulput. Arcaqerluta-llu waten atailngurmek mikelngurmek alairisqevkenata.",
        "translation": "These were the traditional wisdom passed down to us. They also especially told us not to bear illegitimate children."
    },
    "63": {
        "startTime": 462.02,
        "endTime": 466.11,
        "transcript": "Kasngunarqepiallruuq tamana wangkutnun.",
        "translation": "That was very shameful to us."
    },
    "64": {
        "startTime": 466.17,
        "endTime": 471.83,
        "transcript": "Maa-i-llu mat'um nalliini tua-i caunrirluni kasngunairulluni.",
        "translation": "And these days, it's become irrelevant and without shame."
    },
    "65": {
        "startTime": 471.95,
        "endTime": 483.19,
        "transcript": "Cat-wa tua-i qaneryarami-llu waten qanrutkumiimi: \"Cat-gguq tamarmeng kasngunairutarkauguq.\" Ella man'a waten allayuurtellria maa-i.",
        "translation": "It's also because it says this in the Bible: \"Nothing will become shameful anymore.\" The world has changed like this now."
    },
    "66": {
        "startTime": 483.78,
        "endTime": 486.42,
        "transcript": "Taumek murilkeńarqaakut.",
        "translation": "That's why we must be careful."
    },
    "67": {
        "startTime": 486.45,
        "endTime": 493.08,
        "transcript": "Arcaqerluku-llu cali tan'gaurluq elliinek murilkesqaa, murilkesqellruat.",
        "translation": "They escpecially told boys to be careful with themselves."
    },
    "68": {
        "startTime": 493.33,
        "endTime": 504.17,
        "transcript": "Waten arnamun pivailgan nasaurlurmun pisqevkenaku. Nasaurluq tuaten ayuqelria ingluliuresqellrunritaat.",
        "translation": "Before he had a woman, they told him not to be around girls. They told them not to be with girls like that."
    },
    "69": {
        "startTime": 504.43,
        "endTime": 511.06,
        "transcript": "Tua-i-gguq tan'gaurlurmek tuquciarkaungami waten tuqulluku pinrilng'e'rmi.",
        "translation": "They said that she would lead a boy to death even if she doesn't actively murder him."
    },
    "70": {
        "startTime": 511.06,
        "endTime": 519.43,
        "transcript": "Tau͡gaam avani-llu yaaqvaarni tauna tan'gaurluq imumi tamaani elluatuuyuitellrulliniuq.",
        "translation": "But even a very long time ago, a boy would not be perfect."
    },
    "71": {
        "startTime": 519.43,
        "endTime": 524.11,
        "transcript": "Wagg'uq nulirruarluteng nasaurluut-llu uinguarluteng.",
        "translation": "They called it \"pretending to have wives,\" and girls \"pretending to have husbands.\""
    },
    "72": {
        "startTime": 524.14,
        "endTime": 528.44,
        "transcript": "Maa-i tamakulrianek tangyuirutukut watuam nalliini.",
        "translation": "We don't see anyone doing that these days."
    },
    "73": {
        "startTime": 528.88,
        "endTime": 532.99,
        "transcript": "Tau͡gaam avani tamakunek niitetullruunga.",
        "translation": "But I used to hear about them back then."
    },
    "74": {
        "startTime": 533.01,
        "endTime": 543.79,
        "transcript": "Taumek tamakut, tamakut tamaani yuulriit arcaqerluki waten yut'eng inerqutullrulliniit.",
        "translation": "That's why the people who lived back then especially admonished their people like this."
    },
    "75": {
        "startTime": 544.74,
        "endTime": 554.21,
        "transcript": "Waten-llu cali niitetullruunga: \"Yuum-gguq iliin irniani tangvauralriatun anglaniuralriatun ayuqai.\"",
        "translation": "I also used to hear this: \"Some people look at having children is all fun.\""
    },
    "76": {
        "startTime": 554.24,
        "endTime": 558.83,
        "transcript": "Tamana-llu wii maa-i eneqak'la'rqa makunek.",
        "translation": "I also remember that with this people."
    },
    "77": {
        "startTime": 559.22,
        "endTime": 565.83,
        "transcript": "Waten-llu tua-i natmun pivigkailamta agayuya'arqamta",
        "translation": "And because we don't have anywhere else to go like this when we go to church"
    },
    "78": {
        "startTime": 566.61,
        "endTime": 578.2,
        "transcript": "Tua-i waten irniani tayima unilluki kiirrarmi waten yuk piaqan tamana-llu wiinga eneqak'la'rqa qanruyutelleq.",
        "translation": "When they leave their children behind and they are alone like this, I remember that old piece of traditional wisdom."
    },
    "79": {
        "startTime": 578.2,
        "endTime": 589.42,
        "transcript": "Yuum-gguq iliin irniani anglaniuralriatun ayuqai waten qanrucuunaki, camek-llu aarnarqelriamek pingraata qanrucuunaki.",
        "translation": "They say that some people act like having children is all fun without teaching them, and do not say anything even when they do dangerous things."
    },
    "80": {
        "startTime": 589.79,
        "endTime": 592.85,
        "transcript": "Tau͡gaam qanrutnarqaput.",
        "translation": "But we must talk to them."
    },
    "81": {
        "startTime": 593.09,
        "endTime": 605.79,
        "transcript": "Wiinga-llu tua-i ukut qanrutarkanka tayima-llu ilaita niicuumiilngalengraatnga tua-i makut nallunrita'arqenka qanrutkelaryaaqanka wall'u allanun.",
        "translation": "I also speak to those whom I must teach about what I know, even if some of them don't seem to want to listen, or to other children."
    },
    "82": {
        "startTime": 606.35,
        "endTime": 610.82,
        "transcript": "Makut maa-i yuum elluarrluni tau͡gaam yuullerkai.",
        "translation": "These are the things that are only to help people live well."
    },
    "83": {
        "startTime": 611.02,
        "endTime": 624.38,
        "transcript": "Waten qanengssaarnek-llu niitengramta, tua-i niitelaryaaqua-llu wii, tau͡gaam makut maa-i qaneryarat yuum elluarrluki yuullerkai tua-i qanruteknarqaput",
        "translation": "Even though we hear gossip like this, I also hear some too, but we must talk about the traditional wisdom that helps people live good lives"
    },
    "84": {
        "startTime": 624.58,
        "endTime": 627.07,
        "transcript": "Makunun kingumta yuitnun.",
        "translation": "To the people of our descendants."
    },
    "85": {
        "startTime": 627.18,
        "endTime": 636.26,
        "transcript": "Tayima piinanermeggni eneqalarait, eneqalaryaaqelliit waten elluarrluni yuullerkaq.",
        "translation": "They probably remember how to live good lives as they go."
    },
    "86": {
        "startTime": 636.32,
        "endTime": 642.04,
        "transcript": "Maa-i-llu mat'umi nutaan nugtarrluni tuarpiaq makut qanruyutet.",
        "translation": "And now, it truly seems that the traditional wisdom has moved."
    },
    "87": {
        "startTime": 642.23,
        "endTime": 648.82,
        "transcript": "Niiculuni yuulria cam iliiniku-llu nunakegtaarmi uitaarkauniluku.",
        "translation": "It's said that obedient people will someday live in paradise."
    },
    "88": {
        "startTime": 648.99,
        "endTime": 651.71,
        "transcript": "Maa-i makut piyuumirnarqelriit.",
        "translation": "These are desirable."
    },
    "89": {
        "startTime": 651.78,
        "endTime": 654.44,
        "transcript": "Tua-i carraungraan waten qanertua.",
        "translation": "Even though it's not a lot, I've said this."
    },
    "90": {
        "startTime": 655.59,
        "endTime": 656.84,
        "transcript": "Yaa, tua-i-qaa?",
        "translation": "Okay, is that all?"
    },
    "91": {
        "startTime": 657.44,
        "endTime": 661.69,
        "transcript": "Ii-i, tua-i waniw' man'a qanqautekaqa.",
        "translation": "Yes, I've spoken about this."
    },
    "92": {
        "startTime": 663.37,
        "endTime": 666.4,
        "transcript": "Ataucirrarmek call' piyugngauten? (Yaa.)",
        "translation": "Can you speak on one more thing? (Yes.)"
    },
    "93": {
        "startTime": 666.4,
        "endTime": 672.02,
        "transcript": "Maa-i iciw', atanema-am pillruanga unuamek niiquralalriakut",
        "translation": "Now, you know, my superior told me about what we hear about today"
    },
    "94": {
        "startTime": 672.99,
        "endTime": 686.45,
        "transcript": "Mikelnguut akniringqaluteng taqnernun, wall' ilait taqnernun iciw' nangcimaluteng, akusrarcimaluteng, wall' camaluteng.",
        "translation": "About how children are hurt by adults, or, you know, some are beaten, molested, or other things by adults."
    },
    "95": {
        "startTime": 687.32,
        "endTime": 696.41,
        "transcript": "Imumi-qaa elpet ayagyuarullerpeni mikelnguut akusraritektullret wall' akniringqalriit tanglallruuten-qaa?",
        "translation": "Back when you were young, did you see children being molested or hurt?"
    },
    "96": {
        "startTime": 696.42,
        "endTime": 702.82,
        "transcript": "Tangyuitellruunga tamakunek, tamakunek-llu akusrarutekumalrianek.",
        "translation": "I never saw those, or those who were molested."
    },
    "97": {
        "startTime": 703.42,
        "endTime": 716.42,
        "transcript": "Tua-i waniw' tamaani ayagyuallemni tuar tang tua-i niigartellrunrilngua tamakunek akusrarutekumalrianek wall'u nangcimalrianek.",
        "translation": "Back when I was young, it seems that I never heard about those who were molested or beaten."
    },
    "98": {
        "startTime": 716.49,
        "endTime": 721.67,
        "transcript": "Yuut tua-i tamaani wat'um nalliinicetun ayuqenricaaqut.",
        "translation": "People back then were not like now."
    },
    "99": {
        "startTime": 721.8,
        "endTime": 729.58,
        "transcript": "Waten-llu ilait wiinga tanglallruunga marayanek-llu eneluteng.",
        "translation": "I also used to see some with sod houses like this."
    },
    "100": {
        "startTime": 730.14,
        "endTime": 735.03,
        "transcript": "Enaita-llu iluat waten aklurugartaunani, cataunani",
        "translation": "And in their houses, they didn't have a lot of things, almost nothing"
    },
    "101": {
        "startTime": 735.1,
        "endTime": 740.44,
        "transcript": "Makut tau͡gaam waten-ll' inartessuutait, cait tua-i carrait.",
        "translation": "Except for bedding like this, what little they had."
    },
    "102": {
        "startTime": 742.06,
        "endTime": 752.3,
        "transcript": "Tuaten nangcimalriamek arcaqerlua-llu niiteksailnganii tuaten tua-i nangteqluteng yuut yuuyaaqengraata",
        "translation": "I don't think I heard of anything, especially about children abused like that, even though people lived hard lives."
    },
    "103": {
        "startTime": 752.48,
        "endTime": 758.91,
        "transcript": "Tau͡gaam eq'ukluki, caluki, nanglluki, tamakunek niicuitua.",
        "translation": "But I didn't hear about them mistreating them, doing bad things to them, or beating them."
    },
    "104": {
        "startTime": 759.0,
        "endTime": 772.51,
        "transcript": "Maa-i tau͡gaam ukaqvaggun, tuar tang wangni ukaqvaqapigkun tamakunek-llu niitelangelrianga akusrarutekumalrianek nangcimalrianek-llu.",
        "translation": "It's that only recently, only very recently to me, I've started hearing about those who are molested and beaten."
    },
    "105": {
        "startTime": 777.56,
        "endTime": 786.2,
        "transcript": "Imumicetun maa-i mikelnguut ayuqenrilriit maa-i ak'a imumi unuamek-llu.",
        "translation": "Children are no longer how they were like long ago, long ago compared to today."
    },
    "106": {
        "startTime": 786.97,
        "endTime": 794.39,
        "transcript": "Ii-i, maa-i iciw' ava-i qanelrianga mat'um nalliini makut tua-i yuut cimilriit.",
        "translation": "Yes, you know, I've just said that people these days have changed."
    },
    "107": {
        "startTime": 794.64,
        "endTime": 802.76,
        "transcript": "Mikelnguut-llu cali maa-i mat'um nalliini tua-i-am cimirluteng, cimiumaluteng.",
        "translation": "The children these days have also changed."
    },
    "108": {
        "startTime": 802.77,
        "endTime": 809.65,
        "transcript": "Waten avani mikelngurnek waten ayuqelrianek tangyuitellruunga.",
        "translation": "I never used to see children like this back then."
    },
    "109": {
        "startTime": 809.84,
        "endTime": 820.58,
        "transcript": "Taumek waten mikelnguq, wangkuta-w' tua-i Yuungamta, waten-llu kina Kass'atun pingnaq'nge'rmi yuuluni pingaituq.",
        "translation": "That's why a child will not live like these because we are Yup'ik, and even if they are trying to live a Western life."
    },
    "110": {
        "startTime": 820.69,
        "endTime": 827.12,
        "transcript": "Taumek irniarit waten Yugcetun tau͡gaam qanruqu'urluki.",
        "translation": "That's why they should speak to their children only in Yup'ik."
    },
    "111": {
        "startTime": 827.52,
        "endTime": 834.52,
        "transcript": "Wangkuta imumi, wiinga-wa ukut wani irnianka nallumiima, qitevvneq-llu nalluamku",
        "translation": "A long time ago, because we, at least I, didn't know Western things and since I don't know English"
    },
    "112": {
        "startTime": 834.56,
        "endTime": 843.51,
        "transcript": "Waten Yugcetun tamamta maani, qagkut-llu tayima irniateng waten Yugtun qalaruquratullruit.",
        "translation": "All of us here, and probably those up north, would only speak to their children in Yup'ik."
    },
    "113": {
        "startTime": 845.1,
        "endTime": 850.75,
        "transcript": "Taumek maa-i mat'um nalliini tamana umyuaqela'arqa.",
        "translation": "That's why I remember that these days."
    },
    "114": {
        "startTime": 850.77,
        "endTime": 863.26,
        "transcript": "Tayima mikelnguum Kass'aturrlainaq waten elilluni anglilriim qanruyun inerquqaun-llu taringesciigalia mat'um nalliini.",
        "translation": "That's why a child who learn only in English cannot understand traditional wisdom and admonishments anymore these days."
    },
    "115": {
        "startTime": 863.69,
        "endTime": 869.92,
        "transcript": "Taumek maa-i arcaqerluteng yuut cimilriit mikelnguunge'rmeng-llu.",
        "translation": "That's why people, including children, have changed especially today."
    },
    "116": {
        "startTime": 872.49,
        "endTime": 875.03,
        "transcript": "Yaa, tua-i waniw' amllerilria.",
        "translation": "Yes, that's enough now."
    },
    "117": {
        "startTime": 876.26,
        "endTime": 878.52,
        "transcript": "Tua-i? Oh, yaa.",
        "translation": "Is that all? Oh, yes."
    },
    "118": {
        "startTime": 880.22,
        "endTime": 882.18,
        "transcript": "Waten-llu [?]sqellruatnga",
        "translation": "They also asked me to [?] like this"
    },
    "119": {
        "startTime": 885.1,
        "endTime": 897.23,
        "transcript": "Iciw' imumi yuullevet, aren...",
        "translation": "You know, your life back then, I mean..."
    },
    "120": {
        "startTime": 897.88,
        "endTime": 909.05,
        "transcript": "Iciw' anglanarqellrianek-gguq-qaa tangqerraallerpeceńi tengssuutnek wall'u-q' canek tamakunek...",
        "translation": "You know, they asked for funny stories from when you first saw planes or those kinds of things..."
    },
    "121": {
        "startTime": 909.79,
        "endTime": 918.94,
        "transcript": "Irr'ikpiatullruaput, ii-i, tengssuutet waten amllenritellratni, tau͡gaam kiani tengssutetarluni.",
        "translation": "We used to be amazed by them, yes, when there weren't many planes, but there were planes upriver."
    },
    "122": {
        "startTime": 919.2,
        "endTime": 927.6,
        "transcript": "Arcaqerlun' tua-i imna Taqay'aq tamaani tamatum nalliini tengautullruuq avani tayim' Nangllermi.",
        "translation": "Back then at that time, Taqay'aq was the most prominent pilot over in Nanglleq."
    },
    "123": {
        "startTime": 927.75,
        "endTime": 938.11,
        "transcript": "Tua-i tamana tengssuun agiirtaqan, wangkuta-ll' qaill' angtaceta, tua-i ukut-llu nunat iciw' yugyallrunritut; carraullruukut.",
        "translation": "When that plane approached, I'm not sure how big we were, and this village, you know, wasn't heavily populated; there were few of us."
    },
    "124": {
        "startTime": 938.66,
        "endTime": 951.03,
        "transcript": "Tua-llu-w' tua-i wangkuta tayima mikelngull'e'rni pilallilriakut, tamqapiaramta tua-i atraqerrluta maavet ekviim qainganun tauna tengssuun anglanilallrukput",
        "translation": "And then, it was probably we children, every single one of us would go down here to the bluff and have fun watching that plane."
    },
    "125": {
        "startTime": 951.03,
        "endTime": 955.1,
        "transcript": "Makut-llu call' taqnerunge'rmeng irr'iluteng.",
        "translation": "Even these adults would be amazed."
    },
    "126": {
        "startTime": 955.1,
        "endTime": 961.14,
        "transcript": "Qaillun-llu tenglauciit irr'ikluki tengssuutet pitullriit.",
        "translation": "They also used to be amazed wondering how planes flew."
    },
    "127": {
        "startTime": 962.55,
        "endTime": 967.69,
        "transcript": "Tua-i cakneq imkuluki, wangkuta-ll' anglaniaqluta.",
        "translation": "They had a lot of, you know, fun, including us."
    },
    "128": {
        "startTime": 967.94,
        "endTime": 972.44,
        "transcript": "Tauna tua-i arcaqerluni Taqay'aq maavet taitullruuq.",
        "translation": "Taqay'aq was the main one who came here."
    },
    "129": {
        "startTime": 972.64,
        "endTime": 977.62,
        "transcript": "Wii tua-i tamaani tangerqarraalarngatellruaqa tauna tengssuun.",
        "translation": "I think that was the first time that I saw that plane at the time."
    },
    "130": {
        "startTime": 978.55,
        "endTime": 986.61,
        "transcript": "Yaa, kitak-wa tua-i ilakailkuvgu...",
        "translation": "Okay, now if you don't have anything else to add..."
    },
    "131": {
        "startTime": 986.61,
        "endTime": 988.14,
        "transcript": "Canek? (Yugpagnek.)",
        "translation": "About what? (Giants.)"
    },
    "132": {
        "startTime": 988.56,
        "endTime": 991.49,
        "transcript": "Yugpagnek tamakunek wii nalluunga.",
        "translation": "I don't know about those giants."
    },
    "133": {
        "startTime": 991.54,
        "endTime": 997.72,
        "transcript": "Tau͡gaam niitetuyaaqekenka-llu. Mat'um nalliini nalluyagulluki tamakut pianka.",
        "translation": "But I also heard about them. I've forgotten about them now."
    },
    "134": {
        "startTime": 998.66,
        "endTime": 1000.89,
        "transcript": "Tua-i wiinga-llu...",
        "translation": "I also..."
    },
    "135": {
        "startTime": 1001.2,
        "endTime": 1011.17,
        "transcript": "Tau͡gaam tua-i ava-i au͡gkut umyuama tua-i arcaqakelaryaaqekai waten qanruyutet yuum elluarrluki tau͡gaam yuulerkait.",
        "translation": "But in my mind, I think these pieces of traditional wisdom about how people should live well are important."
    },
    "136": {
        "startTime": 1011.48,
        "endTime": 1021.36,
        "transcript": "Waten-llu ca-w' tua-i tamarmi iciw' tua-i makuggnaqluni tayima piyaaqelria.",
        "translation": "And everything, you know, required hard work like this."
    },
    "137": {
        "startTime": 1021.36,
        "endTime": 1033.72,
        "transcript": "Tau͡gaam man'a-llu yuucirrarput cali tuarpiaq makuggnaqluni. Tayima waten assilria atungnaqesteḿini makuggnarqelriatun ayuqeciqsaaqelliuq.",
        "translation": "But our short lives seem to require hard work. It seems that it requires hard work to those who try to do good."
    },
    "138": {
        "startTime": 1034.14,
        "endTime": 1045.39,
        "transcript": "Tau͡gaam akiliutii, yuum assirluni pillrem akiliutii angtuaruuq, yuum waten assirluni ayallerkaa.",
        "translation": "But the reward, the reward for a person who does good is great, how a person should live well."
    },
    "139": {
        "startTime": 1045.5,
        "endTime": 1055.7,
        "transcript": "Maa-i mat'um nalliini ava-i aptellerpetun yuut taqnerunge'rmeng-llu tuarpiaq ayuquciit cimilriit",
        "translation": "These days, as you just asked, even adults seem to have changed."
    },
    "140": {
        "startTime": 1056.14,
        "endTime": 1064.67,
        "transcript": "Arcaqerluku mat'um akusrarutiita tua-i maa-i cimircetlikai, cimircetai",
        "translation": "Their mischievous ways have especially caused them to change"
    },
    "141": {
        "startTime": 1064.92,
        "endTime": 1067.68,
        "transcript": "Cat tayima akusrarrnarqelriit.",
        "translation": "These mischievous ways."
    },
    "142": {
        "startTime": 1067.82,
        "endTime": 1076.86,
        "transcript": "Agumalluku, waten tamatum agumatestii tua-i elluarrluni yuuyuunani.",
        "translation": "Those who go after them do not live well."
    },
    "143": {
        "startTime": 1076.88,
        "endTime": 1083.05,
        "transcript": "Waten-llu ilaminek ayuqniarluni tuarpiaq yuurrluni maa-i mat'um nalliini.",
        "translation": "It seems that they are born envying those around them these days."
    },
    "144": {
        "startTime": 1083.1,
        "endTime": 1087.67,
        "transcript": "Tamatum akusrartellran allurrluku, tuar allurrluku.",
        "translation": "It seems his mischievous ways deprive him of that."
    },
    "145": {
        "startTime": 1088.48,
        "endTime": 1095.41,
        "transcript": "Assirluni waten makutun calriatun pivkenani.",
        "translation": "He is not like those who do well."
    },
    "146": {
        "startTime": 1096.06,
        "endTime": 1099.81,
        "transcript": "Taumek tamakut cat atuyunaicaaqai.",
        "translation": "That's why he should not do those things."
    },
    "147": {
        "startTime": 1099.81,
        "endTime": 1113.28,
        "transcript": "Maa-i nallunrirluki waten inerquutnguciit wall' iquggliquciit nallunrirluki kia tua-i imum atunrilkuniki ellminek ikayurarkauguq.",
        "translation": "If a person learns what is admonished against or what brings misfortune and does not do them, he will help himself."
    },
    "148": {
        "startTime": 1114.32,
        "endTime": 1117.3,
        "transcript": "Yaa, kitak-wa tua-i. Quyana.",
        "translation": "Okay, that's it. Thank you."
    }
};